/**
 * 言語選択コンポーネント
 *
 * @file LanguageSelector.tsx
 * @version 1.0.0
 * @author Japan4U Development Team
 * @summary
 * 多言語対応のための言語選択セレクター。
 * 日本語、韓国語、英語、中国語の4言語をサポート。
 */

import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useNotifications } from './NotificationSystem';
import type { Language } from '../../types';

/**
 * LanguageSelectorコンポーネントのProps型定義
 */
export interface LanguageSelectorProps {
  className?: string;
}

/**
 * 言語選択セレクターコンポーネント
 *
 * @param props - LanguageSelectorProps
 * @returns 言語選択セレクター要素
 */
const LanguageSelector: React.FC<LanguageSelectorProps> = ({ className = 'language-selector' }) => {
  const { currentLanguage, changeLanguage, t } = useLanguage();
  const { success } = useNotifications();

  // 言語変更処理
  const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const lang = event.target.value as Language;
    changeLanguage(lang);

    // 言語変更後の翻訳が更新されるまで少し待ってから通知を表示
    setTimeout(() => {
      const translatedMessage = t('common.notifications.language_changed');
      if (translatedMessage && translatedMessage !== 'common.notifications.language_changed') {
        success(translatedMessage);
      }
    }, 300); // 翻訳リソース更新を待つ
  };

  return (
    <div className={className}>
      <select id="language-select" value={currentLanguage} onChange={handleLanguageChange}>
        <option value="ja">日本語</option>
        <option value="ko">한국어</option>
        <option value="en">English</option>
        <option value="zh">中文</option>
      </select>
    </div>
  );
};

export default LanguageSelector;
